(function(){
  if(window.__gltBundleWidgetLoaded)return; window.__gltBundleWidgetLoaded=true;
  var BARS=12;
  function money(n){return '$'+n.toFixed(2);}
  function boxPrice(){ try{ return window._ABConfig.product.price/100; }catch(e){ return NaN; } }
  function container(){ return document.querySelector('#appstleVolumeDiscountContainer'); }

  function patchRedirect(){
    try{
      if(window._ABConfig&&window._ABConfig.bundle_rules){
        window._ABConfig.bundle_rules.forEach(function(b){b.bundleRedirect='NONE';});
        if(window._ABConfig.bundleRule)window._ABConfig.bundleRule.bundleRedirect='NONE';
        return true;
      }
    }catch(e){}
    return false;
  }
  patchRedirect(); watchDrawer();
  var rp=setInterval(function(){ if(patchRedirect())clearInterval(rp); },25);
  setTimeout(function(){clearInterval(rp);},20000);

  var origFetch=window.fetch;
  window.fetch=function(u){
    var p=origFetch.apply(this,arguments);
    try{
      if(String(u).indexOf('/cart/add')>-1&&(document.body.classList.contains('glt-mode-bundle')||location.pathname.indexOf('/pages/bundle-and-save')>-1)){
        p.then(function(res){ if(res.ok){ setTimeout(openDrawer,400); } });
      }
    }catch(e){}
    return p;
  };
  function refreshDrawer(){
    origFetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'glt-bundle',data:{source:'product-form-component'}}}));
    });
  }
  var gltWatchingDrawer=false;
  function watchDrawer(){
    if(gltWatchingDrawer)return; var d=document.querySelector('cart-drawer-component'); var dialog=d&&d.querySelector('dialog'); if(!dialog)return; gltWatchingDrawer=true;
    new MutationObserver(function(muts){
      muts.forEach(function(m){ if(m.attributeName==='open'&&dialog.open){ refreshDrawer(); setTimeout(refreshDrawer,500); } });
    }).observe(dialog,{attributes:true,attributeFilter:['open']});
  }
  function openDrawer(){
    watchDrawer(); refreshDrawer();
    setTimeout(function(){
      refreshDrawer();
      var d=document.querySelector('cart-drawer-component');
      if(d&&typeof d.open==='function'){ d.open(); } else { var ic=document.querySelector('cart-icon a, cart-icon button, cart-icon'); if(ic)ic.click(); }
      setTimeout(refreshDrawer,500);
    },700);
  }

  var st=document.createElement('style');
  st.textContent=['.glt-guide{margin:6px 0 12px;padding:10px 14px;border-radius:10px;background:rgba(128,128,128,.12);font-size:.9em;text-align:center;font-weight:500}','.glt-guide.glt-done{background:rgba(26,127,55,.16)}','.glt-no-tier .ab-mix-and-match-add-button,.glt-locked .ab-mix-and-match-add-button{pointer-events:none;opacity:.35}','.glt-locked .ab-mix-and-match-selected-variant-qty-wrapper button:last-child{pointer-events:none;opacity:.35}','.ab-mix-and-match-tier-tabs>div{cursor:pointer}','.glt-tab-selected{outline:2px solid currentColor;outline-offset:-2px;border-radius:10px}','.glt-tier-price{font-size:.95em;font-weight:700;margin-top:3px}','.glt-tier-perbar{font-size:.72em;opacity:.7}','.glt-pack-note{font-size:.8em;opacity:.7;margin-left:4px;white-space:nowrap}'].join(' ');
  document.head.appendChild(st);

  var target=null;
  function tabs(){ var c=container(); return c?[].slice.call(c.querySelectorAll('.ab-mix-and-match-tier-tabs > div')):[]; }
  function tabQty(tab){ var q=tab.querySelector('.ab-mix-and-match-tier-tab-qty-value'); return q?parseInt(q.textContent,10):NaN; }
  function count(){
    var c=container(); if(!c)return 0; var n=0;
    [].slice.call(c.querySelectorAll('.ab-mix-and-match-selected-variant-qty-wrapper')).forEach(function(w){
      var m=(w.textContent.match(/\d+/)||[])[0]; n+=m?parseInt(m,10):0;
    });
    return n;
  }

  document.addEventListener('click',function(e){
    var t=e.target;
    var tab=t&&t.closest?t.closest('.ab-mix-and-match-tier-tabs > div'):null;
    if(tab){ var c=container(); if(c&&c.contains(tab)){ var q=tabQty(tab); if(q){ target=q; update(); } } }
  },true);

  function setText(el,msg){ if(el.textContent!==msg)el.textContent=msg; }
  function update(){
    var c=container(); if(!c)return;
    tabs().forEach(function(t){ t.classList.toggle('glt-tab-selected', target!==null&&tabQty(t)===target); });
    var list=c.querySelector('.ab-mix-and-match-product-list');
    if(list){
      var guide=c.querySelector('.glt-guide');
      if(!guide){ guide=document.createElement('div'); guide.className='glt-guide'; list.parentElement.insertBefore(guide,list); }
      var n=count();
      var noTier=(target===null), locked=false, done=false, msg;
      if(noTier){ msg='Step 1 - choose your bundle size above'; }
      else if(n<target){ msg='Step 2 - pick your flavors ('+n+' of '+target+' selected)'; }
      else if(n===target){ locked=true; done=true; msg='Bundle complete ('+n+' of '+target+') - add it to your cart!'; }
      else { msg='You have '+n+' boxes - remove '+(n-target)+' or choose a bigger bundle'; }
      c.classList.toggle('glt-no-tier',noTier);
      c.classList.toggle('glt-locked',locked);
      guide.classList.toggle('glt-done',done);
      setText(guide,msg);
    }
    enhance();
  }

  function enhance(){
    var BOX=boxPrice(); var c=container(); if(!c)return;
    if(!isNaN(BOX)){
      tabs().forEach(function(tab){
        if(tab.querySelector('.glt-tier-price'))return;
        var q=tabQty(tab);
        var dm=(tab.textContent.match(/(\d+(?:\.\d+)?)\s*%/)||[])[1];
        if(!q||dm===undefined)return;
        var total=q*BOX*(1-parseFloat(dm)/100);
        var d1=document.createElement('div');d1.className='glt-tier-price';d1.textContent=money(total);
        var d2=document.createElement('div');d2.className='glt-tier-perbar';d2.textContent=money(total/(q*BARS))+'/bar';
        tab.appendChild(d1);tab.appendChild(d2);
      });
    }
    [].slice.call(c.querySelectorAll('.ab-mix-and-match-product-price-wrap')).forEach(function(w){
      if(w.querySelector('.glt-pack-note'))return;
      var s=document.createElement('span');s.className='glt-pack-note';s.textContent='· 12-pack';
      w.appendChild(s);
    });
  }

  var pending=false;
  new MutationObserver(function(){
    if(pending)return; pending=true;
    requestAnimationFrame(function(){pending=false; update();});
  }).observe(document.body,{childList:true,subtree:true});
  var tries=0, iv=setInterval(function(){ tries++; update(); if(tries>40)clearInterval(iv); },300);
})();
